// extracted by mini-css-extract-plugin
export default {"root":"aBZcbRyW3QtIa03zG62g","wave":"_UvVZz1HaLYHYBd_9sVy","duration":"o_jOq0bnPcM683uas5Vq"};